import React from "react";

import './ConfirmAction.css';

export default function ConfirmAction({handleConfirm, handleCancel}) {
    const handleCancelButtonClick = (event) => {
        event.preventDefault();
        handleCancel();
    }

    const handleConfirmClick = (event) => {
        event.preventDefault();
        handleConfirm();
    }

    return (
        <div className="confirm-action">
            <h3>Confirm Action</h3>
            <div className="button-container">
                <button onClick={handleCancelButtonClick}>Cancel</button>
                <button onClick={handleConfirmClick}>Confirm</button>
            </div>
        </div>
    )
}